import { CONTACT_LIST } from '../index.js';
import ContactCard from './ContactCard';
export default {
  name: 'contact',
  components: {
    ContactCard
  },
  data() {
    return {
      contactList: CONTACT_LIST
    };
  }
};